const STORAGE_KEY = 'lcc_v2_local_prefs_v1'

function empty() {
  return {
    pins: {},
    manualPrimaryAttr: {},
    catchupTab: {},
    catchupExpanded: {},
    cardBackTab: {},
    themeExpanded: {},
    manualMonitor: {}
  }
}

export function loadLccPrefs() {
  try {
    const raw = localStorage.getItem(STORAGE_KEY)
    if (!raw) return empty()
    const parsed = JSON.parse(raw)
    return {
      ...empty(),
      pins: parsed.pins && typeof parsed.pins === 'object' ? parsed.pins : {},
      manualPrimaryAttr:
        parsed.manualPrimaryAttr && typeof parsed.manualPrimaryAttr === 'object'
          ? parsed.manualPrimaryAttr
          : {},
      catchupTab:
        parsed.catchupTab && typeof parsed.catchupTab === 'object' ? parsed.catchupTab : {},
      catchupExpanded:
        parsed.catchupExpanded && typeof parsed.catchupExpanded === 'object'
          ? parsed.catchupExpanded
          : {},
      cardBackTab:
        parsed.cardBackTab && typeof parsed.cardBackTab === 'object' ? parsed.cardBackTab : {},
      themeExpanded:
        parsed.themeExpanded && typeof parsed.themeExpanded === 'object'
          ? parsed.themeExpanded
          : {},
      manualMonitor:
        parsed.manualMonitor && typeof parsed.manualMonitor === 'object' ? parsed.manualMonitor : {}
    }
  } catch (_err) {
    return empty()
  }
}

export function saveLccPrefs(prefs) {
  const payload = {
    ...empty(),
    ...prefs,
    savedAt: new Date().toISOString(),
    storage: 'LOCAL_BROWSER_ONLY'
  }
  localStorage.setItem(STORAGE_KEY, JSON.stringify(payload))
  return payload
}

export function pinCount(prefs) {
  return Object.keys((prefs && prefs.pins) || {}).filter((k) => prefs.pins[k]).length
}
